import { ChipItem } from "./chip-list-types";
import { measureTextWidth, measureTotalTextWidth } from "src/utils/text-measure-utils";

// MUI Chip size="small" puts 8px either side of the label, and chip-list draws a 1px border.
const CHIP_HORIZONTAL_SPACE = 18;

// The gap={1} between chips in the ChipList Stack.
const CHIP_GAP = 8;

// chip-list only keeps a chip while `total + itemWidth < width - 100`, so the last chip needs this
// much clear space behind it before it will render at all.
const OVERFLOW_RESERVE = 100;

// MUI's own defaults for a small Chip's label — the theme doesn't override MuiChip.
export const CHIP_FONT_WEIGHT = 400;
export const CHIP_FONT_SIZE = "0.8125rem";

export const estimateChipWidth = (text: string, font: string): number => measureTextWidth(text, font) + CHIP_HORIZONTAL_SPACE;

/**
 * Width a ChipList needs to show every one of its chips, estimated from the label text rather than
 * the DOM so callers can size a column before the rows exist (or while they are virtualized away).
 * Approximate by construction: a few pixels out costs one chip either way, never a broken layout.
 */
export const estimateChipListWidth = (labels: ChipItem[], font: string): number => {
  if (labels.length === 0) return 0;

  const textWidth = measureTotalTextWidth(
    labels.map(label => label.text),
    font
  );
  return textWidth + labels.length * (CHIP_HORIZONTAL_SPACE + CHIP_GAP) + OVERFLOW_RESERVE;
};
